import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './Button.module.css';
import { cx } from './cx';

/** The five styles of Figma M/Button (46:291 / 46:295 / 46:299 / 46:303 / 46:307). */
export type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost' | 'white';

export interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  children: ReactNode;
  variant?: ButtonVariant;
  /** Full-width (the default in every flow frame, where buttons span the 342 px gutter box). */
  block?: boolean;
  /** Shows a spinner and disables the button; the label stays for layout stability. */
  loading?: boolean;
}

export function Button({
  children,
  variant = 'primary',
  block = true,
  loading = false,
  disabled,
  className,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled ?? loading}
      aria-busy={loading || undefined}
      className={cx(
        styles.button,
        variant !== 'primary' && styles[variant],
        block && styles.block,
        className,
      )}
      {...rest}
    >
      {loading ? <span className={styles.spinner} data-testid="button-spinner" /> : null}
      {children}
    </button>
  );
}
